import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

const generateSessionId = () => {
  // return Math.random().toString(36).substr(2, 9);
  return uuidv4();
};

// const getSessionId = () => {
//   let sessionId = sessionStorage.getItem('sessionId');
//   if (!sessionId) {
//     sessionId = generateSessionId();
//     sessionStorage.setItem('sessionId', sessionId);
//   }
//   return sessionId;
// };

// const getStoredPageViews = (sessionId) => {
//   return localStorage.getItem(`pageViews_${sessionId}`);
// };

// const getStoredVisitedPaths = (sessionId) => {
//   return localStorage.getItem(`visitedPaths_${sessionId}`);
// };

// const storePageViews = (sessionId, count) => {
//   localStorage.setItem(`pageViews_${sessionId}`, count);
// };

// const storeVisitedPaths = (sessionId, paths) => {
//   localStorage.setItem(`visitedPaths_${sessionId}`, JSON.stringify(paths));
// };

const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = generateSessionId();
      sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  } catch (error) {
    console.error('Error while getting or setting session ID:', error);
    // Handle the error as needed (e.g., fallback to a default session ID)
    return generateSessionId();
  }
};

const getStoredPageViews = (sessionId) => {
  try {
    return localStorage.getItem(`pageViews_${sessionId}`);
  } catch (error) {
    console.error('Error while getting stored page views:', error);
    // Handle the error as needed
    return null;
  }
};

const getStoredVisitedPaths = (sessionId) => {
  try {
    return localStorage.getItem(`visitedPaths_${sessionId}`);
  } catch (error) {
    console.error('Error while getting stored visited paths:', error);
    // Handle the error as needed
    return null;
  }
};

const storePageViews = (sessionId, count) => {
  try {
    localStorage.setItem(`pageViews_${sessionId}`, count);
  } catch (error) {
    console.error('Error while storing page views:', error);
    // Handle the error as needed
  }
};

const storeVisitedPaths = (sessionId, paths) => {
  try {
    localStorage.setItem(`visitedPaths_${sessionId}`, JSON.stringify(paths));
  } catch (error) {
    console.error('Error while storing visited paths:', error);
    // Handle the error as needed
  }
};

const usePageViews = (pathname, pageViewLimit = 6) => {
  const [pageViews, setPageViews] = useState(0);
  const [visitedPaths, setVisitedPaths] = useState([]);

  useEffect(() => {
    try {
      const sessionId = getSessionId();
      const storedPageViews = getStoredPageViews(sessionId);
      const storedVisitedPaths = getStoredVisitedPaths(sessionId);

      const initialPageViews = storedPageViews ? parseInt(storedPageViews, 10) : 0;
      const initialVisitedPaths = storedVisitedPaths ? JSON.parse(storedVisitedPaths) : [];

      setPageViews(initialPageViews);
      setVisitedPaths(initialVisitedPaths);
    } catch (error) {
      console.error('Error during initial setup:', error);
      // Handle the error as needed
    }
  }, []);

  useEffect(() => {
    const incrementPageView = () => {
      try {
        const sessionId = getSessionId();
        const storedVisitedPaths = getStoredVisitedPaths(sessionId);

        const visitedPaths = storedVisitedPaths ? JSON.parse(storedVisitedPaths) : [];

        const visited = visitedPaths.includes(pathname);

        if (!visited) {
          const newPageViews = pageViews + 1;
          const newVisitedPaths = [...visitedPaths, pathname];

          setPageViews(newPageViews);
          setVisitedPaths(newVisitedPaths);

          storePageViews(sessionId, newPageViews.toString());
          storeVisitedPaths(sessionId, newVisitedPaths);
        }
      } catch (error) {
        console.error('Error during page view increment:', error);
        // Handle the error as needed
      }
    };

    incrementPageView();
  }, [pathname, pageViews]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      try {
        const sessionId = getSessionId();
        const storedPageViews = getStoredPageViews(sessionId);
        const storedVisitedPaths = getStoredVisitedPaths(sessionId);

        const currentPageViews = pageViews.toString();
        const currentVisitedPaths = JSON.stringify(visitedPaths);

        if (currentPageViews !== storedPageViews) {
          storePageViews(sessionId, currentPageViews);
        }

        if (currentVisitedPaths !== storedVisitedPaths) {
          storeVisitedPaths(sessionId, currentVisitedPaths);
        }
      } catch (error) {
        console.error('Error during beforeunload handling:', error);
        // Handle the error as needed
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [pageViews, visitedPaths]);

  return { pageViews, visitedPaths };
};

export default usePageViews;


// const findSessionWithLongestVisitedPaths = (sessionsData) => {
//   let longestVisitedPaths = [];
//   let sessionIdWithLongestPaths = null;

//   for (const key in sessionsData) {
//     if (key.startsWith('visitedPaths_')) {
//       const visitedPaths = JSON.parse(sessionsData[key]);

//       if (!sessionIdWithLongestPaths || visitedPaths.length > longestVisitedPaths.length) {
//         longestVisitedPaths = visitedPaths;
//         sessionIdWithLongestPaths = key.replace('visitedPaths_', '');
//       }
//     }
//   }

//   return {
//     sessionId: sessionIdWithLongestPaths,
//     longestVisitedPaths: JSON.stringify(longestVisitedPaths),
//   };
// };

// const data = {
//   "pageViews_faa7e923-21bf-4fb9-a1e6-c5db478d18d0": "1",
//   "pageViews_7a3c21d9-d97a-4a60-875a-332e58c61602": "1",
//   "visitedPaths_53ae2aa6-ecf6-44f5-96d6-fde451739dd6": '["/stock/AAPL"]',
//   "setupTime": "1703601738193",
//   "visitedPaths_faa7e923-21bf-4fb9-a1e6-c5db478d18d0": '["/stock/AAPL","/stock/TSLA"]',
//   "globalPageViews": "1",
//   "pageViews_53ae2aa6-ecf6-44f5-96d6-fde451739dd6": "2",
//   "visitedPaths_7a3c21d9-d97a-4a60-875a-332e58c61602": '["/stock/TSLA","/stock/f","/stock/AAPL","/stock/goog","/stock/AMZN"]',
// };

// const result = findSessionWithLongestVisitedPaths(data);
